import React from 'react'
import { InputAdornment } from '@mui/material'
import { getToday } from 'utils/helpers'
import { addToDate } from 'utils/data-manipulation/common'
import { MATERIAL_TYPE_RULES } from 'utils/constants'

export function isManualValidationInfo(isManual, canFlagManualScaleReadOverride) {
  let color
  let startAdornment
  if (canFlagManualScaleReadOverride && isManual) {
    color = 'warning'
    startAdornment = <InputAdornment position="start">*</InputAdornment>
  }
  return { color, startAdornment }
}

export function rowGridHasErrors(errors, id, cell) {
  if (!id) {
    return Object.keys(errors?.materialGrid || {}).some(key => errors?.materialGrid?.[key]?.[cell])
  }
  return errors?.materialGrid?.[id]?.[cell]
}

export const paymentHoldInEffect = (rulesArray = [], effectiveDateValue) => {
  if (rulesArray?.length === 0 || !effectiveDateValue) return false
  const paymentHoldRule = rulesArray.find(rule => rule.type === MATERIAL_TYPE_RULES.PAYMENT_HOLD)
  // Validate the presence and structure of the paymentHoldRule
  if (!paymentHoldRule || !paymentHoldRule.parameters || typeof paymentHoldRule.parameters !== 'object') {
    return false
  }
  const effectiveDate = new Date(effectiveDateValue)
  effectiveDate.setHours(0, 0, 0, 0)
  const days = paymentHoldRule.parameters.days
  const expirationDate = addToDate(effectiveDateValue, parseInt(days, 10))
  expirationDate.setHours(0, 0, 0, 0)
  return expirationDate.getTime() > getToday().getTime()
}

export function getPaymentHoldText(rulesArray = [], effectiveDateValue) {
  if (!paymentHoldInEffect(rulesArray, effectiveDateValue)) return null
  const paymentHoldRule = rulesArray.find(rule => rule.type === MATERIAL_TYPE_RULES.PAYMENT_HOLD)
  const days = paymentHoldRule.parameters.days
  // refer to the date before the effective date lift for "through" date
  const expirationDate = addToDate(effectiveDateValue, parseInt(days, 10) - 1).toLocaleDateString()
  return `Payment Hold: ${days} day payment hold in effect through ${expirationDate}`
}
